import Glide from '@glidejs/glide';

export function glideInit() {

	function syncGlide(original, child) {
		original.on("run", function (e) {
			child.go(e.direction);
		});
	}

	const $propertyGalleries = document.querySelectorAll( '.property-photos' );

	if ( $propertyGalleries ) {
		Object.entries( $propertyGalleries ).forEach(
			( [ index, $instance ] ) => {
				new Glide(
					$instance,
					{
						type: 'carousel',
						focusAt: 'center',
						perView: 1,
					}
				).mount();
			}
		);
	}

	// if (document.querySelector('.property-photos')) {
	// 	var glideBanner = new Glide('.property-photos', {
	// 		type: 'carousel',
	// 		focusAt: 'center',
	// 		perView: 1,
	// 	});
	// 	glideBanner.mount();
	// }

	if (document.querySelector('.banner-slider')) {
		document.querySelectorAll('.banner-slider').forEach(element => {
			var glideBanner = new Glide(element, {
				type: 'carousel',
				focusAt: 'center',
				perView: 1,
				animationDuration: 0,
				gap: 0,
				autoplay: 3000,
				hoverpause: false,
			});
			glideBanner.mount();
		});
	}

	if (document.querySelector('.property-card__images')) {
		document.querySelectorAll('.property-card__images').forEach(element => {

			// If only one slide, fix styling and return.
			const slides = element.querySelectorAll('.property-card__slide');
			if (slides.length <= 1) {
				element.classList.add('property-card__images--single')
				return;
			}

			var glideGallery = new Glide(element.querySelector('.property-card__gallery'), {
				type: 'carousel',
				autoplay: false,
				animationDuration: 0,
				rewind: false,
			});

			glideGallery.on(['mount.after', 'run'], () => {
				const currentIndex = glideGallery.index;
				element.querySelector('.property-indicator__countupdate').innerHTML = currentIndex + 1;
			});

			glideGallery.mount();
		});
	}

}
